module.exports = __webpack_public_path__ + "img/checkbox.1493536b.svg";